import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 4a8 8 0 110 16 8 8 0 010-16zm10 8c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10zM8.5 8a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM14 9.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm2.893 6.997c-.143.31-.408.5-.695.503H7.802c-.287-.002-.552-.194-.695-.503-.143-.31-.143-.69.001-.998C8.118 13.334 9.982 12 12 12c2.018 0 3.882 1.334 4.892 3.499.144.309.144.689.001.998zM12 14c.713 0 1.5.316 2.169 1H9.83c.67-.684 1.456-1 2.169-1z",
      fill: "#2d6ded"
    }
  )
), c = t;
export {
  c as default
};
